import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  DeleteDockClientActions as Actions,
  DeleteDockClientRequestAction as RequestAction,
} from 'store/ducks/dockClients';

export function* deleteDockClientRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.delete, `dock-clients/${id}`);
    onSuccess && onSuccess();
    notify('success', 'Cliente desvinculado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
